<template>
	<div
		ref="dropdown__checkbox__ref"
		class="container__dropdowncheckbox"
	>
		<Button
			semantic-class="tiny"
			:label="label ? label + ' ' + value.filter((f) => f.isActive).length + '' : $t('columns')"
			outlined
			:disabled="isDisabled"
			icon="fas fa-caret-down"
			lefticon
			@click="isCheckboxListActive = !isCheckboxListActive"
		/>
		<ul
			v-show="isCheckboxListActive"
			ref="dropdown__checkbox__list__ref"
			v-closable="{
				exclude: ['dropdown__checkbox__ref', 'dropdown__checkbox__list__ref'],
				handler: 'closeDropdownCheckbox',
			}"
			class="container__dropdowncheckbox__list"
			:class="{ fullWidthList: fullWidthList }"
		>
			<li>
				<div class="action_buttons">
					<Button
						semantic-class="tiny"
						:label="$t('selectAll')"
						:disabled="readonly"
						@click="handleClickAll"
					/>
					<Button
						:disabled="readonly"
						semantic-class="tiny"
						:label="$t('deleteSelected')"
						@click="handleClickDelete"
					/>
				</div>
			</li>
			<li
				v-for="(value, key) in valuesSortedByValue"
				:key="key"
				class="container__dropdowncheckbox__list__item"
			>
				<Checkbox
					:id="value.key"
					:label="value.value"
					:checked="value.isActive"
					:disabled="readonly"
					@click="handleClick($event)"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import Button from '../../components/Button/Button'
import Checkbox from '../Checkbox/Checkbox'

export default {
	components: { Button, Checkbox },

	props: {
		/**
		 * Array que tem os valores que serao colocados em tela
		 * - key: Coluna que serve como um código para o desenvolvedor
		 * - value: Valor que serve para o usuário identificar o que está sendo marcado
		 * - isActive: Valor para saber se o checkbox está ou não marcado
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [Array, Object],
			required: true,
			default: () => {
				return []
			},
		},

		/**
		 * label do botão do dropdown
		 */
		label: String,

		/**
		 * se a lista do componente deve ou não ocupar toda a largura
		 */
		fullWidthList: Boolean,
		/**
		 * habilita apenas para visualização
		 */
		readonly: Boolean,
	},
	emits: ['update:modelValue'],
	data() {
		return {
			rerender: 0,
			/**
			 * Data para controlar se a lista de checkbox deve estar aberta ou fechada
			 */
			isCheckboxListActive: false,
		}
	},

	computed: {
		isDisabled() {
			return this.disabled
		},
		valuesSortedByValue() {
			// return _.orderBy(this.value, ["value"], ["asc"]); //removido ordenação por padrão
			//TODO fazer com que ordenação seja uma das opções do componente
			return this.value
		},
	},
	methods: {
		handleClickAll() {
			this.value.forEach((f) => (f.isActive = true))

			this.$emit('input', this.value)
		},
		handleClickDelete() {
			this.value.forEach((f) => (f.isActive = false))

			this.$emit('input', this.value)
		},
		/**
		 * emite evento para componente pai, enviando estado atual do componente
		 */
		handleClick(event) {
			const checked = event.target.checked
			const key = event.target.id

			this.value.forEach((value) => {
				if (value.key === key) value.isActive = checked
			})

			this.$emit('input', this.value)
		},

		/**
		 * Fecha o dropdown de Checkbox
		 */
		closeDropdownCheckbox() {
			this.isCheckboxListActive = false
		},
	},
}
</script>

<style>
.container__dropdowncheckbox {
	position: relative;
	font-size: 0.75rem;
	color: rgb(var(--color-secondary));
}

.container__dropdowncheckbox__list {
	position: absolute;
	padding: 1rem 3rem 1rem 1rem;
	top: 3rem;
	left: 50%;
	transform: translateX(-50%);
	background-color: white;
	max-height: 15rem;
	overflow-y: auto;
	z-index: 100;
	list-style: none;
	border: 1px solid rgba(var(--color-secondary), 0.2);
	border-radius: 5px;
}

.container__dropdowncheckbox__list.fullWidthList {
	width: 100%;
}

.container__dropdowncheckbox__list__item {
	padding: 0.5rem;
}

.container__dropdowncheckbox__title:hover {
	color: white;
	background-color: rgb(var(--color-secondary));
}

.action_buttons {
	display: flex;
	margin-bottom: 1rem;
}
</style>
